<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<h3 mat-dialog-title>Searches</h3>
<mat-dialog-content fxLayout="column" fxLayoutAlign="start center">
  @for (search of searches$ | async; track search.name) {
    <button mat-button type="button"
      (click)="choose(search.name)">
      {{ search.displayName }}
    </button>
  }
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
